import { PartTypes } from '@parallel-fluidics/shared/constants';
import { getPPartId } from '@parallel-fluidics/shared/models/projects/parts';
import { generateNode, getStepsFromFlow } from 'utils/reactFlowUtils';

export function getProductPartOptions(parts = []) {
  return parts.reduce((products, part) => {
    if (part.type !== PartTypes.PRODUCT) return products;

    const pPartId = getPPartId(part);
    products.push({
      label: `${pPartId} (${part.name})`,
      labelTag: part.status,
      value: pPartId,
      pPartId,
      pPartDocId: part.id,
      metadataArr: part.metadataArr,
      notes: part.notes,
      stepType: part.stepType,
    });

    return products;
  }, []);
}

export function getStepFlowOptions(parts = [], edges = []) {
  const partProducts = getProductPartOptions(parts);
  if (!edges.length || !partProducts.length) return partProducts;

  const nodesData = partProducts.map((part) => generateNode({
    id: part.pPartDocId,
    data: part,
  }));

  const flows = getStepsFromFlow(nodesData, edges);
  const optionMap = new Map();

  flows.forEach((steps) => {
    const lastStep = steps[steps.length - 1];
    optionMap.set(lastStep.pPartId, {
      label: lastStep.label,
      labelTag: lastStep.labelTag,
      value: lastStep.pPartId,
      pPartId: lastStep.value,
      pPartDocId: lastStep.pPartDocId,
      description: steps.map((s) => s.label).join(' -> '),
      steps,
    });
  });

  partProducts.forEach((part) => {
    if (!optionMap.has(part.pPartId)) {
      optionMap.set(part.pPartId, part);
    }
  });

  return optionMap.size > 0 ? Array.from(optionMap.values()) : [];
}

export function buildLineItemSteps({
  parts = [],
  edges = [],
  pPartId,
  quantity = null,
}) {
  const stepFlowOptions = getStepFlowOptions(parts, edges);
  const selectedFlow = stepFlowOptions.find(
    (option) => option.steps?.length > 0 && option.pPartId === pPartId,
  );

  let steps = selectedFlow?.steps || null;

  if (!steps) {
    const containingFlow = stepFlowOptions.find(
      (option) => option.steps?.some((step) => step.pPartId === pPartId),
    );
    if (containingFlow) {
      const selectedIndex = containingFlow.steps.findIndex((step) => step.pPartId === pPartId);
      steps = containingFlow.steps.slice(0, selectedIndex + 1);
    }
  }

  if (!steps?.length) return [];

  return steps.map((step) => ({
    pPartDocId: step.pPartDocId,
    type: step.stepType,
    goal: quantity || null,
    pPartId: step.value,
  }));
}
